import React, { useState, useRef, useEffect, useCallback } from 'react';
import SelectOffice from './SelectOffice'
import SelectDate from './SelectDate'
import SelectTime from './SelectTime'
import SelectDays from './SelectDays'
import DriverAge from './DriverAge'
import ButtonSearch from './ButtonSearch';

import ValidateInput from '../helper/ValidateInputHelper'
import BuildInitialAppStatus from '../helper/BuildInitialAppStatus'
import ErrorModal from './ErrorsModal'

import { inputTypes, postUrl, postUrlWl } from '../const'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCar,
  faChevronDown,
  faAnchor,
  faCalendarAlt,
  faClock,
  faUser,
  faBuilding,
  faPlaneDeparture,
  faHotel,
  faSync
} from '@fortawesome/free-solid-svg-icons'

import '../css/App.scss';

library.add(faCar)
library.add(faChevronDown)
library.add(faCalendarAlt)
library.add(faClock)
library.add(faUser)
library.add(faBuilding)
library.add(faPlaneDeparture)
library.add(faHotel)
library.add(faSync)
library.add(faAnchor)


export default props => {
  const {
    officesTenerife,
    translations,
    defaultParams
  } = props

  const formRefs = {
    Form: useRef(null),
    ZonaBusqueda: useRef(null),
    DepDate: useRef(null),
    HoraSalida: useRef(null),
    OficinaSalida: useRef(null),
    OficinaSalidaTXT: useRef(null),
    otherHotelNamePickup: useRef(null),
    PickupCityId: useRef(null),
    PickupCountryId: useRef(null),
    ZonaBusquedaReturn: useRef(null),
    RetDate: useRef(null),
    HoraRetorno: useRef(null),
    DropoffCityId: useRef(null),
    OficinaRetorno: useRef(null),
    OficinaRetornoTXT: useRef(null),
    OtherHotelNameDropoff: useRef(null),
    DriverDateOdBirth: useRef(null),
    DriverType: useRef(null),
    Language: useRef(null)
  }

  let formUrl = postUrl(translations.language)

  if (document.URL.indexOf('wl-') !== -1) {
    formUrl = postUrlWl(translations.language)
  }


  const [state, setState] = useState(BuildInitialAppStatus(defaultParams))
  const [errors, setErrors] = useState(null)
  const [activeInput, setActiveInput] = useState(inputTypes.none)
  const [searchButtonVersion, setSearchButtonVersion] = useState(0)

  useEffect(() => {
    const handlePageShow = event => {
      if (!event.persisted) return

      setErrors(null)
      setActiveInput(inputTypes.none)
      setSearchButtonVersion(version => version + 1)
    }

    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])


  function checkDates(from, to) {
    var result = false
    if (parseInt(from) < parseInt(to)) {
      result = true;
    }
    return result;
  }

  function pad_with_zeroes(number, length) {
    var result = '' + number;
    while (result.length < length) {
      result = '0' + result;
    }
    return result;
  }

  const hideStaleResults = useCallback(() => {
    var element = document.getElementById("cars-container");
    if (element !== undefined && element !== null) {
      element.style.display = "none";
    }
  }, [])

  const activateInput = useCallback(inputType => {
    if (inputType && inputType !== inputTypes.none) {
      hideStaleResults()
    }
    setActiveInput(inputType || inputTypes.none)
  }, [hideStaleResults])

  function addDays(year, month, day, days) {
    var result = new Date(year, month, day);
    result.setDate(result.getDate() + parseInt(days));
    return result;
  }

  function calculateRentalDays(pickupDate, pickupTime, dropoffDate, dropoffTime) {
    const maxHoursForAddDay = parseFloat(defaultParams.maxHoursForAddDay);
    const threshold = Number.isFinite(maxHoursForAddDay) && maxHoursForAddDay > 0
      ? maxHoursForAddDay
      : 4;
    const pickupTimeParts = (pickupTime || '10:00').split(':');
    const dropoffTimeParts = (dropoffTime || '10:00').split(':');
    const pickupDateTime = Date.UTC(
      parseInt(pickupDate.year, 10),
      parseInt(pickupDate.month, 10) - 1,
      parseInt(pickupDate.day, 10),
      parseInt(pickupTimeParts[0], 10) || 0,
      parseInt(pickupTimeParts[1], 10) || 0
    );
    const dropoffDateTime = Date.UTC(
      parseInt(dropoffDate.year, 10),
      parseInt(dropoffDate.month, 10) - 1,
      parseInt(dropoffDate.day, 10),
      parseInt(dropoffTimeParts[0], 10) || 0,
      parseInt(dropoffTimeParts[1], 10) || 0
    );
    const diffTime = dropoffDateTime - pickupDateTime;

    if (diffTime <= 0) return 0;

    const dayInMilliseconds = 24 * 60 * 60 * 1000;
    if (diffTime < dayInMilliseconds) return 0;

    const fullDays = Math.floor(diffTime / dayInMilliseconds);
    const remainingHours = (diffTime - (fullDays * dayInMilliseconds)) / (60 * 60 * 1000);

    return fullDays + (remainingHours >= threshold ? 1 : 0);
  }

  function cleanString(cadena) {
    var result = cadena;

    do {
      result = result.replace("+", " ");
    } while (result.includes("+"));

    return result;
  }

  const updateState = (newValues) => {
    hideStaleResults()

    if (newValues['days']) {
      var days = newValues['days'];
      var year = state['pickupDate']['year'].toString();
      var month = pad_with_zeroes(state['pickupDate']['month'].toString() - 1, 2);
      var day = pad_with_zeroes(state['pickupDate']['day'].toString(), 2);
      var result = addDays(year, month, day, days);
      state['dropoffDate']['year'] = result.getFullYear();
      state['dropoffDate']['month'] = result.getMonth() + 1;
      state['dropoffDate']['day'] = result.getDate();

    }

    if (newValues['pickupDate']) {
      var year = newValues['pickupDate']['year'].toString();
      var month = pad_with_zeroes(newValues['pickupDate']['month'].toString() - 1, 2);
      var day = pad_with_zeroes(newValues['pickupDate']['day'].toString(), 2);
      var result = addDays(year, month, day, 7);
      state['dropoffDate']['year'] = result.getFullYear();
      state['dropoffDate']['month'] = result.getMonth() + 1;
      state['dropoffDate']['day'] = result.getDate();
      newValues['days'] = calculateRentalDays(
        newValues['pickupDate'],
        state['pickupTime'],
        state['dropoffDate'],
        state['dropoffTime']
      );

      defaultParams.pickupTime = '16:00';
    }

    if (newValues['dropoffDate']) {
      var to = newValues['dropoffDate']['year'].toString() + pad_with_zeroes(newValues['dropoffDate']['month'].toString(), 2) + pad_with_zeroes(newValues['dropoffDate']['day'].toString(), 2);
      var from = state['pickupDate']['year'].toString() + pad_with_zeroes(state['pickupDate']['month'].toString(), 2) + pad_with_zeroes(state['pickupDate']['day'].toString(), 2);
      var result = checkDates(from, to);
      if (result) {
        newValues['days'] = calculateRentalDays(
          state['pickupDate'],
          state['pickupTime'],
          newValues['dropoffDate'],
          state['dropoffTime']
        );
      }
      else
        newValues['days'] = 0;
    }

    if (Object.prototype.hasOwnProperty.call(newValues, 'pickupTime') ||
      Object.prototype.hasOwnProperty.call(newValues, 'dropoffTime')) {
      newValues['days'] = calculateRentalDays(
        state['pickupDate'],
        newValues['pickupTime'] || state['pickupTime'],
        state['dropoffDate'],
        newValues['dropoffTime'] || state['dropoffTime']
      );
    }

    const newState = Object.assign({}, state, newValues)
    setState(newState)
    setActiveInput(inputTypes.none)
  }



  const submitSearch = () => {

    const errors = ValidateInput.check(state, formRefs, translations)

    if (errors.length > 0) {
      setErrors(errors)
      return
    }

    formRefs.Form.current.submit()
  }

  return (
    <div id='searcher'>
      <div id="pickOffice">
        <label className='labelSpace'>{decodeURI(translations.pickupOffice)}</label>
        <SelectOffice
          style={{ gridArea: 'pickup-office' }}
          onClick={() => setActiveInput(inputTypes.pickupOffice)}
          isPickup={true}
          officeId={31902}
          officeName={decodeURI(cleanString(state.pickupOffice.name)) || translations.pickupPlaceholder}
          ariaLabel={decodeURI(translations.pickupOffice)}
          selectedOfficeId={state.pickupOffice.idZone}
          officesTenerife={officesTenerife}
          selectOffice={value => {
            const newValues = { pickupOffice: value }
            newValues.dropoffOffice = value
            updateState(newValues)
          }}
          forceClose={activeInput != inputTypes.pickupOffice}
          setActiveInput={activateInput}
          inputType={inputTypes.pickupOffice}
          translations={translations}
        />
      </div>

      <div id='pickOfficeDates'>
        <label className='labelSpace'>{translations.datePickup}</label>
        <div id="cajaFechas1">
          <SelectDate
            language={translations.language}
            style={{ gridArea: 'pickup-date' }}
            date={state.pickupDate}
            forceClose={activeInput != inputTypes.pickupDate}
            setActiveInput={activateInput}
            inputType={inputTypes.pickupDate}
            ariaLabel={translations.datePickup}
            onChange={value => updateState({ pickupDate: value })}
          />
          <SelectTime
            style={{ gridArea: 'pickup-time' }}
            hour={state.pickupTime}
            forceClose={activeInput != inputTypes.pickupTime}
            setActiveInput={activateInput}
            inputType={inputTypes.pickupTime}
            ariaLabel={`${translations.datePickup} ${state.pickupTime}`}
            onChange={value => updateState({ pickupTime: value })}
          />

        </div>

      </div>
      <div id="daysBox">
        <label className='labelSpace'>{decodeURI(translations.daysM)}</label>
        <p id="daysLiteral">{decodeURI(translations.reservationLeyend1)} <strong>{state.days} {decodeURI(translations.days)}</strong></p>
        <SelectDays
          id="selectorDias"
          style={{ gridArea: 'days' }}
          days={state.days}
          onChange={value => updateState({ days: value.days })}
        />
      </div>

      <div id="pickOffOffice">
        <label className='labelSpace'>{decodeURI(translations.dropoffOffice)}</label>
        <SelectOffice
          style={{ gridArea: 'dropoff-office' }}
          onClick={() => setActiveInput(inputTypes.dropoffOffice)}
          isDropOff={true}
          officeId={31902}
          officeName={decodeURI(cleanString(state.dropoffOffice.name)) || translations.dropoffPlaceholder}
          ariaLabel={decodeURI(translations.dropoffOffice)}
          selectedOfficeId={state.dropoffOffice.idZone}
          officesTenerife={officesTenerife}
          selectOffice={value => updateState({ dropoffOffice: value })}
          forceClose={activeInput != inputTypes.dropoffOffice}
          setActiveInput={activateInput}
          inputType={inputTypes.dropoffOffice}
          translations={translations}
        />
      </div>

      <div id='pickOfficeDatesReturn'>

        <label className='labelSpace'>{decodeURI(translations.dateDropOff)}</label>

        <div id="cajaFechas2">

          <SelectDate
            language={translations.language}
            style={{ gridArea: 'dropoff-date' }}
            date={state.dropoffDate}
            forceClose={activeInput != inputTypes.dropoffDate}
            setActiveInput={activateInput}
            inputType={inputTypes.dropoffDate}
            ariaLabel={decodeURI(translations.dateDropOff)}
            onChange={value => updateState({ dropoffDate: value })}
          />

          <SelectTime
            style={{ gridArea: 'dropoff-time' }}
            hour={state.dropoffTime}
            forceClose={activeInput != inputTypes.dropoffTime}
            setActiveInput={activateInput}
            inputType={inputTypes.dropoffTime}
            ariaLabel={`${decodeURI(translations.dateDropOff)} ${state.dropoffTime}`}
            onChange={value => updateState({ dropoffTime: value })}
          />

        </div>

      </div>


      <div id="driverBox">
        <label className='labelSpace'>{translations.age}</label>
        <div id="driverplain">
          <DriverAge
            style={{ gridArea: 'driver-age' }}
            age={state.driverAge}
            minAge={state.minDriverAge}
            driverType={state.driverType}
            forceClose={activeInput != inputTypes.userAge}
            setActiveInput={activateInput}
            inputType={inputTypes.userAge}
            onChange={value => updateState({ driverType: value })}
            textRegularDriver={translations.textRegularDriver}
            textYoungDriver21={translations.textYoungDriver21}
            textYoungDriver23={translations.textYoungDriver23}
            DriverLeyend={translations.age}
          />
          {/* <div id="cerca">
   <ButtonSearch onClick={submitSearch} active={!errors} text={translations.textSearchButton} /> 
   </div> */}
        </div>

      </div>

      <div id="cerca2">
        <ButtonSearch key={searchButtonVersion} id="btncerca2" onClick={submitSearch} active={!errors} text={translations.textSearchButton} />
      </div>



      <form ref={formRefs.Form} style={{ display: 'none' }} action={formUrl} method='post'>
        <input type='hidden' ref={formRefs.ZonaBusqueda} name='zonaBusqueda' />
        <input type='hidden' ref={formRefs.DepDate} name='depDate' />
        <input type='hidden' ref={formRefs.HoraSalida} name='horaSalida' />
        <input type='hidden' ref={formRefs.OficinaSalida} name='oficinaSalida' />
        <input type='hidden' ref={formRefs.OficinaSalidaTXT} name='oficinaSalidaTXT' />
        <input type='hidden' ref={formRefs.otherHotelNamePickup} name='otherHotelNamePickup' />
        <input type='hidden' ref={formRefs.PickupCityId} name='pickupCityId' />
        <input type='hidden' ref={formRefs.PickupCountryId} name='pickupCountryId' />
        <input type='hidden' ref={formRefs.ZonaBusquedaReturn} name='zonaBusquedaReturn' />
        <input type='hidden' ref={formRefs.RetDate} name='retDate' />
        <input type='hidden' ref={formRefs.HoraRetorno} name='horaRetorno' />
        <input type='hidden' ref={formRefs.DropoffCityId} name='dropoffCityId' />
        <input type='hidden' ref={formRefs.OficinaRetorno} name='oficinaRetorno' />
        <input type='hidden' ref={formRefs.OficinaRetornoTXT} name='oficinaRetornoTXT' />
        <input type='hidden' ref={formRefs.OtherHotelNameDropoff} name='otherHotelNameDropoff' />
        <input type='hidden' ref={formRefs.DriverDateOdBirth} name='driverDateOdBirth' />
        <input type='hidden' ref={formRefs.DriverType} name='DriverType' />
        <input type='hidden' ref={formRefs.Language} name='language' value={translations.language} />

        <input type="submit" value="" name="btnSubmit" id="searchSubmitButton" />
      </form>

      <ErrorModal
        errors={errors}
        close={() => setErrors(null)}
        textClose={translations.errors.closeWindow}
        textTitle={translations.errors.missPickupLocation.title}
      />
    </div>
  )
}
